module.exports = __webpack_public_path__ + "img/MarcoMARCIA_400x400.cd24f925.jpg";